import { Assert } from '@team/assert';
import { EMPTY_ARRAY_LENGTH } from './const.js';

export const isEmpty = (value: UnknownArray) =>
  Assert.isEquals(value.length, EMPTY_ARRAY_LENGTH);
